import React, { useState } from 'react';
import  {MarketingHeadFlow} from '../ReusableComp/NavBarLeft';
import NavigationBar from '../ReusableComp/NavigationBar';
import Select from '../ReusableComp/Select';
import { Col, Container, Row, Stack, Table } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { getMHSubjectList,resetSubjectProfile,resetAEStepperData,resetEventDetails, getEventDetails,getSAdvEvents,getqrdashboardCounts2,getmsdashboardcounts, getAllCausalities,getAllOutComes,getActionTaken,getActionTakenForAE, getAdvEventOfSubject, getSubjProfDetails, getMHAdvEventOfSubject, getMHSubjProfDetails, getReviewerComments, getPmsNotifications} from '../../Redux/actions/actions';

import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { SUBJECT_STATUS_OFF_STUDY,EVENT_CLASSIFICATION_LEVEL_BRIGHTON,EVENT_CLASSIFICATION_OTHER, EVENT_CLASSIFICATION_GRADE_CTCAE, SUBJECT_STATUS_ON_GOING_ADVERSE_EVENT, SUBJECT_STATUS_ON_STUDY, EVENT_CLASSIFICATION_AESI, PRINCIPAL_INVESTIGATOR, MARKETING_HEAD } from '../../utilities';
import moment from 'moment';
import { FaEye, FaDownload, FaTimes } from 'react-icons/fa';
import { formatDate } from '../ReusableComp/dateFormat';
import { useNavigate, useLocation } from "react-router";
import { Modal, Button } from 'react-bootstrap';


const MarketingHeadSubjectList = () => {
    const dispatch = useDispatch();
    const [zoneSelected, setZoneSelected] = useState("");
    const mssitesdropdown = useSelector((state) => state.mssitesdropdown );
    const getEventFlag = useSelector((state) => state.getEventFlag);
    const mhSubjectList = useSelector((state) => state.mhSubjectList);
    const subjectProfile = useSelector((state) => state.getSubProf);
    const qrSubjectcounts = useSelector((state) => state.qrSubjectcounts);
    const msdbcounts = useSelector((state) => state.mhsubjectlistcounts)
    const reviewerComments = useSelector((state) => state.reviewerComments);
    const [filteredData, setFilteredData] = useState(null);
    const [searchText, setSearchText] = useState('');
    const eventDtls = useSelector((state) => state.eventDtls)
    let [loading_flag, Setloading_flag] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [flag, setFlag] = useState(false);
  const location = useLocation();

  const [asc,setAsC]=useState(false);
  const [desc,setDesc]=useState(false);
  let extensions=""

    useEffect(() => {
      Setloading_flag(true);
      if (eventDtls?.action_taken_for_adverse_event_name !== "None") {
        setFlag(true);
      }
      else {
        setFlag(false)
      }
      
        dispatch(getMHSubjectList(
            {
                study_id: localStorage.getItem("study_id"),
                zone_id: localStorage.mh_zone_id,
            }
        ));
        if (subjectProfile) {
          Setloading_flag(false)
        }
        
    }, [dispatch,eventDtls,localStorage.study_id,localStorage.mh_zone_id,subjectProfile]);
  
    useEffect(()=>{
      if(mhSubjectList){
        if(selectedOption ==="serious_adverse_events"){
          setFilteredData(mhSubjectList.filter(i => i.sae_count>0))
        }
        else if(selectedOption ==="adverse_events"){
          setFilteredData(mhSubjectList.filter(i => i.ae_count>0))
        }
        else if(selectedOption ==="all_events"){
          setSelectedOption("all_events")
          setFilteredData(mhSubjectList)
        }else{
          setFilteredData(mhSubjectList)
        }
      }
      setTimeout(() => {
        Setloading_flag(false);
      }, 200);
    },[mhSubjectList])

    const [myArray, setMyArray] = useState([]);
    const [subjProfData, setSubjProfData] = useState({});
    const aeSubject = useSelector((state) => state.getAeOfSubj);

    useEffect(() => {
        const dateOfReport = aeSubject && aeSubject?.date_of_administration;
        
        if (subjectProfile !== null) {
            setSubjProfData({
                subject_dose_id: subjectProfile && subjectProfile['SubjectDoses.subject_dose_id'],
                subject_id: subjectProfile.subject_id,
                study_id: subjectProfile.study_id,
                date_of_administration: dateOfReport
            });
            let status = `${subjectProfile['SubjectDoses.status']}`
            setMyArray([
                { id: 1, title: subjectProfile['Study.study_name'], description: 'Study' },
                { id: 2, title: `D${subjectProfile['SubjectDoses.dose']}`, description: 'Dose' },
                { id: 3, title: `${subjectProfile['PrincipalInvestigator.name']}`, description: 'Principal Investigator' },
                {
                    id: 4, title: "Status", description:
                        status == SUBJECT_STATUS_ON_GOING_ADVERSE_EVENT ? 'On going adverse event' :
                            status == SUBJECT_STATUS_ON_STUDY ? 'On study' :
                                status == SUBJECT_STATUS_OFF_STUDY ? 'Concluded study' : ''
                }
            ])
        }
    }, [dispatch, subjectProfile]);

    const dateOfReport = aeSubject?.date_of_administration;
    const lastDayActiveFollowUp = aeSubject?.last_day_active_follow_up;
    const stepperData = [];
    const afterFollowUpStepperData = [] ;
    const date = new Date(dateOfReport);
    const startDate = new Date(dateOfReport);
    while (date <= new Date(lastDayActiveFollowUp)) {
        stepperData.push({
            day: `Day ${Math.round((date - startDate) / (1000*3600*24))}`,
            dateOfevent: date.toISOString().split("T")[0]
        });
        date.setDate(date.getDate() + 1);
    }
    const events = aeSubject?.events;

    var i = 0;
    if(events)
    {  
        while(i < Object.keys(events).length){
            const eventDate = stepperData.filter(date => date.dateOfevent == (Object.keys(events)[i]).toString().split("T")[0]);
            if(eventDate.length == 0)
            {   
              const test = (Object.keys(events)[i]).toString().split("T")[0]
              const date = new Date(test)
                afterFollowUpStepperData.push({
                    day: `Day ${Math.round((date - startDate) / (1000*3600*24))}`,
                    dateOfevent: (Object.keys(events)[i]).toString().split("T")[0],
                })
            }
            i = i+1
        }
    }
    
    const modifiedData1 = stepperData.map(day => {
        const eventDate = Object.keys(events).find(date => date === day.dateOfevent);
        if (eventDate) {
            return {
                ...day,
                eventClassification: [events[eventDate]]
            };
        }
        return day;
    });

    const modifiedData2 = afterFollowUpStepperData?.map((event) => {
        return {
            ...event,
            eventClassification: [events[event.dateOfevent]]
        };
    });

    const modifiedData = modifiedData2?.length>0 ? [...modifiedData1, ...modifiedData2] : [...modifiedData1]

    function disableBackButton() {
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', function(event) {
          window.history.pushState(null, null, window.location.pathname);
        });
      }
      useEffect(() => {
        disableBackButton();
      }, [])
    
      function handlePageandStudy() {
        setCurrentPage(1)
        Setloading_flag(false)
        dispatch(resetAEStepperData())
        dispatch(resetSubjectProfile())
    }
    function handlePageandStudy1() {
      setCurrentPage(2)
      // dispatch(resetEventDetails())
  }

  function handlePageandStudy2() {
    setCurrentPage(2)
    // dispatch(resetEventDetails())
}
const [currentPage, setCurrentPage] = useState(
  location.state == undefined || location.state == null
    ? 1
    : location.state.data
);
    
const cleanText =
eventDtls?.study_case_definition === EVENT_CLASSIFICATION_AESI ? eventDtls?.input_notes_aesi_others :
  eventDtls?.study_case_definition === EVENT_CLASSIFICATION_LEVEL_BRIGHTON ? eventDtls.study_event_meets_case_definition || eventDtls.study_event_doesnt_meets_case_definition :
    eventDtls?.study_case_definition === EVENT_CLASSIFICATION_GRADE_CTCAE ? eventDtls.study_ctcae_definition :
      eventDtls?.study_case_definition === EVENT_CLASSIFICATION_OTHER ? eventDtls?.input_notes_aesi_others : '';
const [selectedMS, setSelectedMS] = useState({});

const handleBackClick = () => {
    setCurrentPage(1)
}
const [loading, setLoading] = useState(false);
const mhMainStudies = useSelector((state) => state.mhMainStudies);
const handleAE = (adverse_event_mapping_id) => {
    let obj = {
      subject_id: subjectProfile.subject_id,
      dose: subjectProfile['SubjectDoses.dose']
    }
    dispatch(getPmsNotifications({
      user_id: localStorage.login_user_id,
        user_persona: MARKETING_HEAD,
        study_id: mhMainStudies?.map(item => item.study_id),
        zone_id: localStorage.getItem("mh_zone_id")
    }))
    dispatch(getMHSubjProfDetails(obj))
    setLoading(true);
    dispatch(getEventDetails({ adverse_event_id: adverse_event_mapping_id }))
    dispatch(getReviewerComments({
      adverse_event_mapping_id: adverse_event_mapping_id
    }))
    dispatch(getSAdvEvents())
    dispatch(getAllCausalities())
    dispatch(getAllOutComes())
    dispatch(getActionTaken())
    dispatch(getActionTakenForAE())
    setCurrentPage(3)
  }
  const JustBtwn = "d-flex justify-content-between";

const handleSubjectData =(data1)=>{
  Setloading_flag(true)

    setSelectedMS(data1)
    setCurrentPage(2)
    let subjectId = data1.subject_id
        let dose = parseInt(data1.dose.substring(1))
        setCurrentPage(2)
        // setSubjData(data)
        if (subjectId) {
            dispatch(getMHAdvEventOfSubject(subjectId, dose))
            dispatch(getMHSubjProfDetails({ "subject_id": subjectId, "dose": dose }))
        }
        const dateOfReport = aeSubject && aeSubject?.date_of_administration;
        
        if (subjectProfile !== null) {
            Setloading_flag(false)

            setSubjProfData({
                subject_dose_id: subjectProfile && subjectProfile['SubjectDoses.subject_dose_id'],
                subject_id: subjectProfile.subject_id,
                study_id: subjectProfile.study_id,
                date_of_administration: dateOfReport
            });
            let status = `${subjectProfile['SubjectDoses.status']}`
            setMyArray([
                { id: 1, title: subjectProfile['Study.study_name'], description: 'Study' },
                { id: 2, title: `D${subjectProfile['SubjectDoses.dose']}`, description: 'Dose' },
                { id: 3, title: `${subjectProfile['PrincipalInvestigator.name']}`, description: 'Principal Investigator' },
                {
                    id: 4, title: "Status", description:
                        status == SUBJECT_STATUS_ON_GOING_ADVERSE_EVENT ? 'On going adverse event' :
                            status == SUBJECT_STATUS_ON_STUDY ? 'On study' :
                                status == SUBJECT_STATUS_OFF_STUDY ? 'Concluded study' : ''
                }
            ])
        }
}

const getRoleCode =(data)=>{
}
const handleOptionSelectZone =(e)=>{
    let val = e.target.value;
    setZoneSelected(val);
    dispatch(getmsdashboardcounts(
      {
        studyID: localStorage.getItem("studyID"),
        siteID: e.target.value
    }))
    dispatch(getMHSubjectList(
        {
            study_id: localStorage.getItem("studyID"),
            zone_id: localStorage.mh_zone_id,           
        }
    ));
    setFilteredData(null)
}
    const [doseOptions, setDoseOptions] = useState(null);
    const [statusOptions, setStatusOptions] = useState(null);
    const [siteOptions, setSiteOptions]=useState(null);
    const [doseSelected, setDoseSelected] = useState("");
    const [statusSelected, setStatusSelected] = useState("");
    const [siteSelected, setSiteSelected]=useState("");

useEffect(() => {
    if (mhSubjectList?.length > 0) {
        const uniqueDoses = Array.from(new Set(mhSubjectList.map(json => json.dose))).filter(Boolean);
        const optionsList = uniqueDoses.map((dose) => ({
            label: dose,
            value: dose
        }));
        setDoseOptions(optionsList);

        const uniqueStatus = Array.from(new Set(mhSubjectList?.map(json => json.status))).filter(Boolean);
        const optionsStatusList = uniqueStatus?.map((val) => ({
            label: val,
            value: val
        }));
        setStatusOptions(optionsStatusList);

        const uniqueSites = Array.from(new Set(mhSubjectList?.map(json => json.site_name))).filter(Boolean);
        const optionsSitesList = uniqueSites?.map((val) => ({
            label: val,
            value: val
        }));
        setSiteOptions(optionsSitesList);
    }
    
}, [mhSubjectList]);

  
    const handleSearchData = (event) => {
      const searchText = event.target.value.toLowerCase();
      setSearchText(searchText);
      
      const filteredData1 = mhSubjectList?.filter((item) => {
          const { dose, status, first_name, last_name, subject_code } = item;
          
          // Check if the properties exist and convert them to lowercase for case-insensitive search
          const formattedFirstName = (first_name || "").toLowerCase();
          const formattedLastName = (last_name || "").toLowerCase();
          const formattedSubjectCode = (subject_code || "").toLowerCase();
          const formattedDose = (dose || "").toLowerCase();
          const formattedStatus = (status || "").toLowerCase();
          
          // Combine different search criteria using logical operators (&& and ||)
          return (
              ((formattedFirstName + formattedLastName).includes(searchText) || 
              formattedSubjectCode.includes(searchText) ||
              formattedDose.includes(searchText) ||
              formattedStatus.includes(searchText))
              &&
              formattedDose.includes(doseSelected) &&
              formattedStatus.includes(statusSelected)
          );
      });
      
      // Update the table or do whatever you want with the filteredData
      setFilteredData(filteredData1);
  };
  

    const handleOptionSelectSite = (e) => {
      let val = e.target.value;
      if (val === 'Sites') {
          val = "";
      }
      setSiteSelected(val)
      const filteredData = mhSubjectList?.filter((item) => {
          // Convert relevant properties to lowercase for case-insensitive search
          const { dose, status,site_name } = item;

          const formattedSubjectCode = dose;
          const formattedPhoneNumber = status ? status : "";
          const formattedSiteName  = site_name ? site_name : "";
          // Check if subject_id or subject_code contains the search text
          return (
              formattedSubjectCode.includes(doseSelected) &&
              formattedPhoneNumber.includes(statusSelected) &&
              formattedSiteName.includes(val)
          );
      });
      // Update the table or do whatever you want with the filteredData
      setFilteredData(filteredData);

  }
    const handleOptionSelectDose = (e) => {
      let val = e.target.value;
      if (val === 'Doses') {
          val = "";
      }
      setDoseSelected(val)
      const filteredData = mhSubjectList?.filter((item) => {
          // Convert relevant properties to lowercase for case-insensitive search
        
          const { dose, status, site_name } = item;

          const formattedSubjectCode = dose;
          const formattedPhoneNumber = status ? status : "";
          const formattedSiteName  = site_name ? site_name : "";
          // Check if subject_id or subject_code contains the search text
          return (
              formattedSubjectCode?.includes(val) &&
              formattedPhoneNumber?.includes(statusSelected) &&
              formattedSiteName?.includes(siteSelected)
          );
      });
      // Update the table or do whatever you want with the filteredData
      setFilteredData(filteredData);

  }
  const handleOptionSelectStatus = (e) => {
      let val = e.target.value;
      if (val === 'Status') {
          val = "";
      }

      setStatusSelected(val)
      const filteredData = mhSubjectList.filter((item) => {
          const { dose, status, site_name } = item;

          const formattedSubjectCode = dose;
          const formattedPhoneNumber = status ? status : "";
          const formattedSiteName  = site_name ? site_name : "";
          return (
              formattedSubjectCode.includes(doseSelected) &&
              formattedPhoneNumber.includes(val) && 
              formattedSiteName.includes(siteSelected)
          );
      });
      setFilteredData(filteredData);

  }
  const [selectedOption, setSelectedOption] = useState(getEventFlag?.option);  

  const handleRadioChange = (selectedValue) => {
    setSelectedOption(selectedValue);
    if (selectedValue === 'serious_adverse_events') {
      setFilteredData(mhSubjectList.filter(i => i.sae_count>0))
    } else if (selectedValue === 'adverse_events') {
      setFilteredData(mhSubjectList.filter(i => i.ae_count>0))
    }else if (selectedValue === 'all_events') {
      setFilteredData(mhSubjectList)
    }
  };

  const dashboardCards = [
    {
        count: msdbcounts?.saesCount,
        image: './images/icons/exclamatory.svg',
        desc: 'Serious Adverse Event',
        bgcolor: '#D14141',
        id:"serious_adverse_events"
    },
    {
        count: msdbcounts?.aesCount,
        image: './images/icons/smiley.svg',
        desc: 'Adverse Events',
        bgcolor: '#EA9E4F',
        id:"adverse_events"
    },
    {
        count: msdbcounts?.subjectsCount,
        image: './images/icons/subjects_white.svg',
        desc: 'Total Subjects',
        bgcolor: '#8DA2B5',
        id:"all_events"
    },
]

    const exportToExcel = () => {
        const workbook = XLSX.utils.book_new();
        const sheetData = [];
      
        // Prepare the header row
        const headerRow = ['Subject ID','Name', 'Gender', 'Age','Last Updated', 'Dose', 'Events', 'Status'];
        sheetData.push(headerRow);
      
        // Prepare the data rows
        const dataRows = filteredData || mhSubjectList;
        dataRows.forEach((item) => {
          const rowData = [
            item.subject_code, item.first_name+" "+item.last_name, item.sex, item.age+' Yrs', item.lastUpdated,item.dose,item.events,item.status,
          ];
          sheetData.push(rowData);
        });
      
        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      
        // Convert the workbook to an Excel file
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      
        // Create a Blob from the buffer
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      
        // Save the Blob as an Excel file
        saveAs(blob, 'Marketing_Head_Subjects_List.xlsx');
      };

    const handleClearFilters = () => {
        setDoseSelected("");
        setStatusSelected("");
        setSiteSelected("");
        setFilteredData(mhSubjectList);
    }
      const [studyOption, setStudyOption] = useState()
      const handleSetFilter = () => {
        setFilteredData(null)
      }
        const handleOptionChange=(e, key, value)=>{
          setStudyOption( value)
        }

        const handleViewClick = (document) => {
          setSelectedDocument(document);
        };

        function calculateBMI(weight, height) {
          if (isNaN(weight) || isNaN(height)|| height === null) {
            return "0"; // Display "N/A" if either weight or height is not a number
        }
          const bmi = weight / ((height / 100) ** 2);
      
          return bmi.toFixed(1);
      }

    

      const handleAscending = () => {
        setAsC(true);
        setDesc(false);

        const sortedData = [...filteredData];      
          sortedData.sort((a, b) => {
          const subjectCodeA = a.subject_code;
          const subjectCodeB = b.subject_code;
      
          return subjectCodeA.localeCompare(subjectCodeB);
        });
      
        setFilteredData(sortedData);
      };
      
      const handleDescending = () => {
        setDesc(true);
        setAsC(false);
      
        const sortedData = [...filteredData];
      
        sortedData.sort((a, b) => {
          const subjectCodeA = a.subject_code;
          const subjectCodeB = b.subject_code;
          return subjectCodeB.localeCompare(subjectCodeA);
        });
      
        setFilteredData(sortedData);
      };

      const getStatusTextColor = (status) => {
        switch (status) {
          case 'ON STUDY':
            return 'black';
          case 'CONCLUDED STUDY':
            return 'green';
          case 'ON GOING ADVERSE EVENT':
            return 'red';
          default:
            return ''; 
        }
      };

      function getIcon(fileExtension) {
        switch (fileExtension) {
          case 'pdf':
            return "./images/icons/reshot-icon-pdf.svg"
          case 'ppt':
            return "./images/icons/reshot-icon-ppt.svg"
          case 'txt':
            return "./images/icons/reshot-icon-txt.svg"
          case 'docx':
            return "./images/icons/reshot-icon-docx.svg"
          case 'doc':
            return "./images/icons/reshot-icon-doc.svg"
          case 'xls':
            return "./images/icons/reshot-icon-xls.svg"
          case 'csv':
            return "./images/icons/reshot-icon-csv.svg"
          case 'jpg':
            return "./images/icons/reshot-icon-jpg.svg"
          case 'png':
            return "./images/icons/reshot-icon-png.svg"
          case 'jpeg':
            return "./images/icons/reshot-icon-jpeg.svg"
         }
      }
      const handleOpenModal = (document) => {
        setSelectedDocument(document);
      };
    
      const handleCloseModal = () => {
        setSelectedDocument(null);
      };
      const isImage = (url) => {
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
        return imageExtensions.includes(url);
      };


    return (
        <div>
            <NavigationBar title={'Adverse Events Of Subject'}
            studyDropdwn={currentPage === 1 ? false : true}
            rolecode={getRoleCode} handleOptionChange={handleOptionChange} handleFilter = {handleSetFilter} filterCondition = {0}/>
            {/* <MarketingHeadFlow /> */}
            <div className='main_body '>
                {currentPage===1 && <Container fluid className='pt-3 pb-3 py-lg-2 py-md-2 py-xxl-4 mblbgclr '>
                    <Stack direction="horizontal" gap={3} className=" p-0 pb-md-2 pb-lg-2 pb-xxl-3 add_subject_stack">
                    <div className=" d-flex justify-content-between justify-content-md-start  gap-2 pilistfiltrs">
                        
                        {/* <div>
                            <select 
                            value={zoneSelected}
                            className="selectItem"
                                onChange={handleOptionSelectZone}
                            >
                              {mssitesdropdown && mssitesdropdown.map((item) => 
                                {
                                  return <option value={item.value}>{item.label}</option>
                                }
                              )

                              }
                              </select>
                        </div> */}
                        <div className=" ">
                            {
                                <select
                                value={siteSelected}
                                onChange={handleOptionSelectSite}
                                className="custom-select"
                                style={{ width: "auto" }}
                              >
                                <option value={"Sites"}>Sites</option>
                                {siteOptions?.map((option) => (
                                  <option key={option.value} value={option.value} title={option.label}>
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                            }
                        </div>
                        <div className=" ">
                            {
                                <Select
                                    selectedOption={doseSelected}
                                    selectdivstyl={""}
                                    name={"classification"}
                                    width={"auto"}
                                    label={""}
                                    options={doseOptions}
                                    initialValue={"Doses"}
                                    onChange={handleOptionSelectDose}
                                />
                            }
                        </div>
                      </div>

                    <div className=" d-flex justify-content-between justify-content-md-start gap-2 pilistfiltrs mb-4 mb-lg-0 mb-md-0">

                        <div>
                            {
                                <Select
                                    selectedOption={statusSelected}
                                    selectdivstyl={""}
                                    name={"classification"}
                                    width={"auto"}
                                    label={""}
                                    options={statusOptions}
                                    initialValue={"Status"}
                                    onChange={handleOptionSelectStatus}
                                />
                            }
                        </div>
                        <div>
                            <button className="orange_btn" onClick={handleClearFilters}>Clear</button>
                        </div>
                      </div>

                    </Stack>
                    <Container fluid className="p-0">
                        <Row className="d-flex pb-2">
                            {dashboardCards.map((card, index) => {
                                return (
                                  <Col key={index} xs={6} md={4} className={`pb-md-0 ps-0 pe-0 ${index ===0 || index===1 ? 'pe-2 pb-2':''}`}>
                                        <div className='card-container C-pointer' style={{ backgroundColor: card.bgcolor ,outline: selectedOption === card.id ? "2px solid black" :""}}
                                        onClick={() => handleRadioChange(card.id)}
                                        >
                                            <div className='content'>
                                                <span>{card.count}</span>
                                                <img src={card.image} alt="" />
                                            </div>
                                            <div className='desc'>{card.desc}</div>
                                        </div>
                                    </Col>
                                )
                            })}
                        </Row>

                    </Container>
                    <Container fluid className='pitable_container p-0'>
                        <Row className='searchbar '>
                            <Col className='searchFiled gap-2 gap-md-3'>
                                <label htmlFor="" />
                                <input type="text" value={searchText} onChange={handleSearchData} placeholder='Search with name' />
                                <div className=" ">
                                        <button
                                            className="btn btn-success"
                                            onClick={exportToExcel}
                                            style={{height:"42px"}}
                                        >
                                           <span className='fa-download-icon'><i className="fa-solid fa-download"/></span>
                                            <span className='dwld_txt'>Download XLS</span>
                                            <img src="./images/icons/download.svg" alt="#" style={{marginLeft:"5px"}}/>
                                        </button>
                                    </div>
                            </Col>
                        </Row>
                        <div>
                        {loading_flag  ? (
                                <div className=''>
                                <img
                                  className="atrium_loader"
                                  src="/images/circle-effect-loading.gif"
                                  alt="Loader"
                         
                                />
                              </div>
                            ) : (
                        <div className='' >
                          {filteredData === null && localStorage.study_id ? <div className=''>
                            <img
                                className="atrium_loader"
                                src="/images/circle-effect-loading.gif"
                                alt="Loader"

                            />
                          </div> :  <Table bordered size="sm" className='pitable mssubjlistmbl'>
                            <thead className='sticky_table_header'>
                                <tr>
                                    <th>S.No </th>
                                    <th className='sticky-header'>
                                    <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                          <span style={{ fontSize: 14, fontWeight: 600, marginTop: 0,paddingLeft:"40%" }}>Subject ID</span>
                            <svg width="30" height="30" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" style={{float:"right"}}>
                              <g id="icon_sort">
                                <path id="icon" d="M13.3471 21.1433C13.1481 21.4277 12.7269 21.4277 12.5279 21.1433L8.23821 15.0152C8.00624 14.6839 8.24332 14.2285 8.64783 14.2285H17.2272C17.6317 14.2285 17.8688 14.6839 17.6368 15.0152L13.3471 21.1433Z" fill={desc?"black":"#E1E5E7"} onClick={handleDescending} className='svg-cursor'/>
                                <path id="icon_2" d="M13.3471 4.31368C13.1481 4.02932 12.7269 4.02932 12.5279 4.31368L8.23821 10.4418C8.00624 10.7732 8.24332 11.2285 8.64783 11.2285H17.2272C17.6317 11.2285 17.8688 10.7732 17.6368 10.4418L13.3471 4.31368Z" fill={asc?"black":"#E1E5E7"} onClick={handleAscending} className='svg-cursor'/>
                              </g>
                            </svg>
                            </div>
                        </th>
                                    <th>Name
                                    </th>
                                    <th>Gender
                                    </th>
                                    
                                    <th>Age
                                    </th>
                                    <th>Last Updated
                                    </th>
                                    
                                    <th>Dose
                                    </th>
                                    <th>Events
                                    </th>
                                    <th>Status
                                    </th>
                                    <th>Action
                                    </th>
                                </tr>
                            </thead>
                            {filteredData === null ? 
                                <tbody>
                                <tr className='text-center'>
                                <td colSpan='10'>No records found</td>
                                </tr>
                            </tbody>
                            :
                            <>
                            {filteredData.length > 0?(
                             
                            <tbody >
                                {filteredData?.map((i, index)=>{
                                    let formatedDate=formatDate(i.lastUpdated)
                                    return(
                                        <tr key={index} className='text_left_table' >
                                        <td className='text_right_sno'>{index +1}</td>
                                        <td>{i.subject_code ? i.subject_code : "-"}</td>
                                        <td>{i.first_name ? i.first_name : "-"}{" "}{i.last_name ? i.last_name : "-"}</td>
                                        <td>{i.sex ? i.sex : "-"}</td>
                                        <td>{i.age ? i.age : "-"}{' Yrs'}</td> 
                                        <td className='text-center'>{formatedDate}</td>
                                        <td>{i.dose ? i.dose : "-"}</td>
                                        <td>{i.events ? i.events : "-"}</td>
                                        <td style={{ color: getStatusTextColor(i.status) }}>{i.status ? i.status : "-"}</td>
                                        <td className=' mb-0 align-items-center viewbtnstylmbl' onClick={() => handleSubjectData(i)}><article>{i.status ? i.status : "-"}</article> <h3 className='mb-0'>{">"}</h3></td>
                                        <td className='viewbtnstyl'>
                                            <button className="gray_btn px-3" onClick={()=>handleSubjectData(i)}>
                                            View
                                            </button> 
                                        </td>
                                </tr>
                                    )})}  
                            </tbody>
                             )
                            :
                            (
                            
                                <tbody>
                                    <tr className='text-center'>
                                    <td colSpan='10'>No records found</td>
                                    </tr>
                                </tbody>
                                  
                            )
                            }
                            </>
                            }
                            
                        </Table>}
                        </div>
                        )}
                        </div>

                    </Container>
                </Container>}
                {loading_flag ? <div className=''>
                                        <img
                                            className="atrium_loader"
                                            src="/images/circle-effect-loading.gif"
                                            alt="Loader"
                                        />
                                    </div>  : (currentPage === 2 && subjectProfile) && 
                <Container fluid className='py-3 page_two_styl'>
                <Row className='d-flex justify-content-between'>
                    <Col className='ps-0'><button className="white_btn white_btn_back" onClick={handlePageandStudy}>{'< '}Back</button> </Col>
                </Row>
                <Container fluid className='py-2 py-md-3 py-lg-3 py-xxl-3 p-0 '>
                    <Row className='SVdtl_Main'>
                        <Col lg={4} className='section_1'>
                            <div className='pisubj_left_main'>

                                <div className='title_cls title_clsmbl'>
                                    <h5>Subject Profile</h5>
                                </div>
                                <div className="left_content_subjlist">
                                    <div className='body_cls'>
                                        {/* <span><h6 className='mb-0'>{subjectProfile?.first_name}{" "+subjectProfile?.last_name}</h6></span> */}
                                        <span><h6>{subjectProfile?.subject_code}</h6></span>
                                            
                                                 <div className="row">
                          <div className="col-6 p-0">
                            <div className="mb-0">
                              <span className="mb-0" style={{padding:"0px"}}>Age:</span> <span className="space_yrs highlet-left">{subjectProfile?.age} Yrs</span>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="mb-0">
                              <span className="mb-0">Height:</span> <span className='space_height highlet-left'>{subjectProfile?.height ? subjectProfile.height : 0} cm</span>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6 p-0">
                            <div className="mb-0">
                              <span className="mb-0">Gender:</span> <span className='highlet-left'>{subjectProfile?.sex}</span>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="mb-0">
                              <span className="mb-0">Weight:</span> <span className='highlet-left'>{subjectProfile?.weight}Kg</span>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12 p-0">
                            <div className="mb-0">
                              <span className="mb-0">BMI:</span> <span className="space_bmi highlet-left">{calculateBMI(subjectProfile?.weight, subjectProfile?.height)} (BMI)</span>
                            </div>
                          </div>
                          
                                                </div>   
                                        <span className='d-flex justify-content-between w-100'>
                                            <h6 className='site_add'>{subjectProfile && subjectProfile['Site.site_name']} </h6>
                                            <img className='' src="./images/icons/location.svg" alt="Location Icon" />
                                        </span>
                                    </div>
                                    <div className='px-3 s2 studydtlsmbl'>
                                        {myArray.map((i, index) => {
                                            return (
                                                <div className='studytab' key={index}>
                                                    <span className='text-start'>{i.title}</span>
                                                    <span className="study_tab_desc">{i.description}</span>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col className=' pisub' >
                        <div className='title_cls right_cntnt right_cntntmbl'>
                                <h5 className='title'>Adverse Events</h5>
                            </div>
                            <div className='p-3 p-md-5 p-lg-5 right_content_stepper'>
                                <div className='text-left '>
                                
                                    <Stepper events={modifiedData}  handleAE={(id) => handleAE(id)}/>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>
                }
                {currentPage === 3 && (
                <Container fluid className="p-3 page_two_styl">
                <Row className='d-flex justify-content-between'>
    <Col className='d-md-none'>
        <button className="white_btn white_btn_back" onClick={handlePageandStudy2}>{'< '}Back</button>
    </Col>
</Row>

                <Container fluid className='py-2 py-md-3 py-lg-3 py-xxl-3 p-0'>
                  <Row className="SVdtl_Main custm_pdng_aedtls">
                    <Col xs={12} lg={4} className="section_1 col-lg-4">
                      {subjectProfile && 
                      <div className="left_content_subjlist">

                        {/* <div className="review_min_high review_min_highmbl  "> */}

                          <div className="p-3 body_cls s2 studydtlsmbl">
                            {/* <h6 className="mb-0">
                              {subjectProfile?.first_name}
                              {" "+subjectProfile?.last_name}
                            </h6> */}

                            <span>

                              <h6 className="mt-3">{subjectProfile?.subject_code}</h6></span>

                          <div className="row">
                          <div className="col-6 p-0">
                            <div className="mb-0">
                              <span className="mb-0" style={{padding:"0px"}}>Age:</span> <span className="space_yrs highlet-left">{subjectProfile?.age} Yrs</span>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="mb-0">
                              <span className="mb-0">Height:</span> <span className='space_height highlet-left'>{subjectProfile?.height ? subjectProfile.height : 0} cm</span>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6 p-0">
                            <div className="mb-0">
                              <span className="mb-0">Gender:</span> <span className='highlet-left'>{subjectProfile?.sex}</span>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="mb-0">
                              <span className="mb-0">Weight:</span> <span className='highlet-left'>{subjectProfile?.weight}Kg</span>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12 p-0">
                            <div className="mb-0">
                              <span className="mb-0">BMI:</span> <span className="space_bmi highlet-left">{calculateBMI(subjectProfile?.weight, subjectProfile?.height)} (BMI)</span>
                            </div>
                          </div>
                          
                                                </div>  

                            <span className="d-flex justify-content-between w-100">

                              <h6 className="site_add">
                                {subjectProfile['Site.site_address']}
                              </h6>
                              <img
                                className=""
                                src="./images/icons/location.svg"
                                alt="Location Icon"
                              />
                            </span>
                          </div>
                          <div className="px-3 s2 studydtlsmbl">
                            {myArray.map((i, index) => {
                              return (
                                <div className="studytab" key={index}>
                                  <span className="text-start">{i.title}</span>
                                  <span className="study_tab_desc">
                                    {i.description}
                                  </span>
                                </div>
                              );
                            })}
                          </div>
                          <div className="px-3 s2">
                          {reviewerComments && reviewerComments?.filter(i => i.user_persona === PRINCIPAL_INVESTIGATOR).length > 0 && 
                        <div className="studytab">
                          <span className="text-start">
                            Principal Investigator Comments
                          </span>
                          {reviewerComments && reviewerComments?.filter(
                            i => i.user_persona === PRINCIPAL_INVESTIGATOR
                          ).map((i, index) => {
                            return (
                              <div key={index}>

                                <div className="qr_cmts_txt d-flex flex-row">
                                  <li></li>
                                  <div>{i.comment}</div>
                                </div>
                                <span className="qr_cmts_date ">
                                  By : {i.created_by} {", "} On :{" "} 
                                  {moment(i.createdAt).format("DD/MM/YYYY HH:mm:ss")}
                                </span>
                              </div>

                            );
                          })
                          }
                        </div>}

                      </div>
                        </div>
                      // </div>
                      }
                    </Col>
                    <div className="col review_event_header pisub">
                      <div className='title_cls right_cntnt right_cntntmbl'>
                        <h5 className="mb-1">Events</h5>
                        {/* <span >1 of 2</span> */}
                      </div>

                      <Col className="py-1 px-md-4 py-md-3 qr_right_content">
                        <div className="d-flex justify-content-between flex-lg-row flex-column">

                          <div className=" ">
                            <label htmlFor="dateOfonSet" className="custm_label_fw">
                              Date of onset
                            </label>
                            <input
                            value={eventDtls?.date_of_onset} 
                              // value={moment(eventDtls?.date_of_onset).format("DD-MM-YYYY")}
                              className="customInput"
                              id="dateOfonSet"
                              type="date"
                              placeholder="Enter Here"
                              disabled
                              aria-placeholder="#D4D4D4"
                              style={{
                                padding: "16px 12px",
                                width: "340px",
                                cursor: "not-allowed",
                              }}
                              onKeyDown={(e) => e.preventDefault()}
                            />
                          </div>

                          <div className="">
                            <label htmlFor="timeOfonSet" className="custm_label_fw">
                              Time of onset (24 Hrs)
                            </label>
                            <input
                              value={eventDtls?.time_of_onset}
                              className="customInput "
                              disabled
                              id="timeOfonSet"
                              type="time"
                              placeholder="Enter Here"
                              aria-placeholder="#D4D4D4"
                              style={{ padding: "16px 12px", width: "340px" }}
                            />
                          </div>
                        </div>
                        <div className="d-flex justify-content-between flex-lg-row flex-column ">
                          <div className="">
                            <label
                              htmlFor="dateOfResolution"
                              className="custm_label_fw"
                            >
                              Date of resolution
                            </label>
                            <input
                              value={eventDtls?.date_of_resolution} 
                              // value={moment(eventDtls?.date_of_resolution).format("DD-MM-YYYY")}
                              disabled
                              className="customInput "
                              id="dateOfResolution"
                              // min={minDate}
                              type="date"
                              placeholder="Enter Here"
                              aria-placeholder="#D4D4D4"
                              style={{
                                padding: "16px 12px",
                                width: "340px",
                                cursor: "not-allowed",
                              }}
                              onKeyDown={(e) => e.preventDefault()}
                            />
                          </div>

                          <div className="">
                            <label htmlFor="lastName" className="custm_label_fw">
                              Time of resolution (24 Hrs)
                            </label>
                            <input
                              value={eventDtls?.time_of_resolution}
                              disabled
                              className="customInput"
                              id="lastName"
                              type="time"
                              placeholder="Enter Here"
                              aria-placeholder="#D4D4D4"
                              style={{ padding: "16px 12px", width: "340px" }}
                            />
                          </div>
                        </div>

                        
                        <div >
                        <div htmlFor="lastName" className="custm_label_fw">
                          Past Health History
                        </div>
                        <div className={`d-flex justify-content-lg-between flex-lg-row flex-column mb-4`}>
                          <div>
                            <label htmlFor="lastName" className="">
                              Allergies
                            </label>
                            <input
                              value={eventDtls?.allergies ? eventDtls.allergies : '-'}
                              disabled
                              className="customInput"
                              id="lastName"
                              type="text"
                              aria-placeholder="#D4D4D4"
                              style={{ padding: "16px 12px", width: "340px" }}
                            />
                          </div>
                          <div>
                            <label htmlFor="medical_history" className="">
                            Medical history
                            </label>
                            <input
                              value={eventDtls?.medical_history ? eventDtls.medical_history : '-'}
                              disabled
                              className="customInput"
                              id="medical_history"
                              type="text"
                              aria-placeholder="#D4D4D4"
                              style={{ padding: "16px 12px", width: "340px" }}
                            />
                          </div>

                        </div>

                        <div className={`d-flex justify-content-lg-between flex-lg-row flex-column`}>
                          <div>
                            <label htmlFor="lastName" className="">
                              Concurrent Illness
                            </label>
                            <input
                              value={eventDtls?.concurrent_illness ? eventDtls.concurrent_illness : '-'}
                              disabled
                              className="customInput"
                              id="lastName"
                              type="text"
                              aria-placeholder="#D4D4D4"
                              style={{ padding: "16px 12px", width: "340px" }}
                            />
                          </div>
                        </div>

                        </div>
                        {eventDtls?.serious_adverse_event_name &&
                          <Row className="d-flex align-items-center">

                            <Col>
                              <label htmlFor="lastName" className="custm_label_fw">
                                Serious adverse event criteria
                              </label>
                            </Col>
                            <Col>
                              <span>
                                <button className="red_btn advesre-serious" > {eventDtls?.serious_adverse_event_name}</button>
                              </span>
                            </Col>
                          </Row>
                        }
                        {eventDtls?.study_aebank_event_title !== null && <Row className="d-flex align-items-center">
                          <Col>
                            <label htmlFor="lastName" className="custm_label_fw">
                              Adverse event
                            </label>
                          </Col>
                          <Col>
                            <span>
                              <button className="orange_btn advesre-serious" > {eventDtls?.study_aebank_event_title}</button>
                            </span>
                          </Col>
                        </Row>}
                        <div className="advEventGroup">
                          <div className="p-4 bg-light rounded eventClassificationDiv">
                            <div className="custm-radio-styl reviewlist">
                              <div className="reviewaetilte">
                                <label
                                  htmlFor="notmetcase"
                                  style={{
                                    display: "flex",
                                    alignItems: "start",

                                  }}
                                >
                                  <input
                                    type="radio"
                                    id="notmetcase"
                                    checked
                                    style={{ width: "20px" }}
                                  />
                                  <span
                                    style={{ marginLeft: "10px" }}
                                  >
                                    <div className="custm-radio-styl ">
                                      {eventDtls?.study_event_meets_case_definition !== null ?
                                        "Event meet case definition" :
                                        eventDtls?.study_event_doesnt_meets_case_definition !== null ?
                                          "Event does not meet case definition" :
                                          eventDtls?.study_ctcae_definition !== null ?
                                            "Grade" :
                                          eventDtls?.study_aebank_event_title && eventDtls?.study_case_definition == EVENT_CLASSIFICATION_AESI ? 'Adverse Event of Special Interest' : 'Other'
                                      }
                                    </div>
                                  </span>
                                </label>
                              </div>

                              <div className="subtext">
                                <img src="./images/icons/checkedbox.svg" alt="" />
                                <span>{cleanText}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      

                        <div className={` gap-2 border p-3 rounded`}>
                          <div className="d-flex flex-column gap-3 ">
                            <div className={`d-flex justify-content-lg-between flex-lg-row flex-column`}>
                              <div className="mb-3 mb-lg-0">
                                <label htmlFor="causality">
                                  Causality
                                </label>
                                <input
                                  value={eventDtls?.causality_name}
                                  disabled
                                  className="customInput"
                                  id="lastName"
                                  type="text"
                                  placeholder="Enter Here"
                                  aria-placeholder="#D4D4D4"
                                  style={{ padding: "16px 12px", width: "340px" }}
                                />
                              </div>
                              <div className="mb-3">
                                <label htmlFor="outCome">
                                  Outcome
                                </label>
                                <input
                                  value={eventDtls?.outcome_name}
                                  disabled
                                  className="customInput"
                                  id="lastName"
                                  type="text"
                                  placeholder="Enter Here"
                                  aria-placeholder="#D4D4D4"
                                  style={{ padding: "16px 12px", width: "340px" }}
                                />
                              </div>
                            </div>
                            <div className={`d-flex justify-content-lg-between flex-lg-row flex-column`}>
                            <div className="mb-3">
                                <label htmlFor="actionTaken">
                                Action Taken For Study Vaccine 
                                </label>
                                <input
                                  value={eventDtls?.action_taken_name}
                                  disabled
                                  className="customInput"
                                  id="lastName"
                                  type="text"
                                  placeholder="Enter Here"
                                  aria-placeholder="#D4D4D4"
                                  style={{ padding: "16px 12px", width: "340px" }}
                                />
                              </div>
                              <div className="mb-3">
                                  <label htmlFor="actionTaken">
                                    Action Taken For Adverse Event
                                  </label>
                                  <input
                                  value={eventDtls?.action_taken_for_adverse_event_name}
                                  disabled
                                  className="customInput"
                                  id="lastName"
                                  type="text"
                                  placeholder="Enter Here"
                                  aria-placeholder="#D4D4D4"
                                  style={{ padding: "16px 12px", width: "340px" }}
                                />
                            
                                </div>
                            
                            </div>
                            </div>
                            <div className="d-flex justify-content-between ">
                          {flag && (
                            <div className="start-end-date">
                              <label htmlFor="startDate" className="custm_label_fw">
                                <p className="adverse-auto">Treatment Start Date</p>
                              </label>
                              <input
                                value={eventDtls?.start_date_of_treatment}
                                className="custminputbml selectTag"
                                id="start_date_of_treatment"
                                type="date"
                                disabled
                                placeholder="Enter Start Date"
                                aria-placeholder="#D4D4D4"
                                style={{ padding: "16px 12px", width: "340px" }}

                              />
                            </div>
                          )}
                          {/* End Date input */}
                          {flag && (
                            <div className="start-end-date">
                              <label htmlFor="endDate" className="custm_label_fw">
                                <p className="adverse-auto">Treatment End Date</p>
                              </label>
                              <input
                                value={eventDtls?.end_date_of_treatment}
                                className="custminputbml selectTag"
                                id="end_date_of_treatment"
                                type="date"
                                disabled
                                placeholder="Enter End Date"
                                aria-placeholder="#D4D4D4"
                                style={{ padding: "16px 12px", width: "340px" }}

                              />
                            </div>
                          )}
                        </div>
                        </div>

                                   <div>
  {selectedDocument && !['xlsx', 'xls'].includes(extensions) && (
    <Modal show={selectedDocument !== null} onHide={handleCloseModal} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isImage(extensions) ? (
          <img
            src={selectedDocument.document_url}
            title="Preview"
            width="100%"
            height="500px"
            style={{ border: '1px solid #ccc', width: "100%" }}
          />
        ) : (
          <iframe
            src={selectedDocument.document_url}
            title="Preview"
            width="100%"
            height="500px"
            style={{ border: '1px solid #ccc' }}
          />
        )}
      </Modal.Body>
    </Modal>
  )}
</div>
                        

                        
                      </Col>
                    </div>

                    <div className="registrationStepsFooter" >
                    <button className="white_btn white_btn_back" onClick={handlePageandStudy1}>{'< '}Back</button>
                    </div>
                    
                  </Row>
                </Container>

                </Container>
                )}
            </div>

        </div>
    );
};

export default MarketingHeadSubjectList;

const Stepper = ({ events, handleAE }) => {
  return <>
    <div className='mb-3 dor_note'>{"("}<span className='text-danger'>*</span>{")"} - The date of resolution has not been added to the events.</div>
    { events?.map((i, index) => {
            let yellowDot
            let seriousDot
            let greenDot = i?.eventClassification && i?.eventClassification[0]?.adverse_events[0]?.isEventEnd || i?.eventClassification && i?.eventClassification[0]?.serious_adverse_events[0]?.isEventEnd
            let greenOrange = ((i?.eventClassification && i?.eventClassification[0]?.ongoingAdverseEvents >= 1) || (i?.eventClassification && i?.eventClassification[0]?.startedAdverseEvents >= 1)) && i?.eventClassification && i?.eventClassification[0]?.endedEvents >= 1
            let saeStartEnd = i?.eventClassification && i?.eventClassification[0]?.endedEvents >= 1 && (i?.eventClassification && i?.eventClassification[0]?.startedSeriousAdverseEvents >= 1 || i?.eventClassification && i?.eventClassification[0]?.ongoingSeriousAdverseEvents >= 1)
            let aeStartEnd = i?.eventClassification && i?.eventClassification[0]?.endedEvents >= 1 && i?.eventClassification && i?.eventClassification[0]?.startedAdverseEvents >= 1
           
            i.eventClassification != null && i.eventClassification?.map(i => {
                yellowDot = (i.adverse_events?.length !== 0)
            })
            i.eventClassification != null && i.eventClassification?.map(i => {
                seriousDot = i.serious_adverse_events?.length !== 0
            })
            let formattedStringg = i.day?.replace(/(\D)(\d+)/, '$1 $2');
            return (
                <Row className='stprmainmbl' >
                    <div className='vertical_stepper_main col-5 col-md-3 col-lg-3 col-xxl-3'>
                        <div className='vertical_stepper_section' key={index}>
                            <Col className='dataleft'>
                                <div className=' fw-bold'>{formattedStringg}</div>
                                <div className='date'>{moment(i.dateOfevent).format("DD-MM-YYYY")}</div>
                            </Col>
                        </div>
                    </div>
                    <div className='vertical_stepper_main col'>
                        <div className={`vertical_stepper_dots ${events.length-1 == index ? "border-0" : ""}`}>
                            <div className='vertical_stepper_section' key={index}>
                                <Col className={`${(greenOrange || saeStartEnd) ? "dot-green-inside": "dot"} ${aeStartEnd && "outer-orange"}  ${saeStartEnd ? "outer-red" :greenOrange ? "outer-orange" : greenDot ? "C-green" : seriousDot ? "C-red" : !seriousDot && yellowDot ? "C-orange" : "C-gray"}`} />

                                {i.eventClassification!=null && i.eventClassification?.map((i, index) => {
                                    const startEvents = i.adverse_events.filter((each) => each.isEventStart)
                                    const endEvents = i.adverse_events.filter((each) => each.isEventEnd)
                                    const ongoingAE = i.adverse_events.filter((each) => each.isEventStart ===  false && each.isEventEnd === false)
                                    const ongoingSAE = i.serious_adverse_events.filter((each) => each.isEventStart ===  false && each.isEventEnd === false)
                                    const startSaEvents = i.serious_adverse_events.filter((each) => each.isEventStart)
                                    const endSaEvents = i.serious_adverse_events.filter((each) => each.isEventEnd)
                                    const noOfEvents = startEvents.length+endEvents.length+ongoingAE.length+ongoingSAE.length+startSaEvents.length+endSaEvents.length
                                    return (
                                      <div key={index} className={`aestylmbl ${noOfEvents >= 3 && "pb-4"}`} >
                                          <div className='adveventstyl'>
                                              {ongoingAE.length > 0 && <div className="d-flex flex-wrap">
                                              {ongoingAE.length > 0 && ongoingAE.map((each,index) => {
                                                  return  <div key={each.adverse_event_mapping_id} className='aechildmbl clickable-string serious-adverse-event' onClick={() => handleAE(each.adverse_event_mapping_id, true)}>
                                                  {each.study_aebank_event_title}
                                                  {index === ongoingAE?.length - 1 ? (ongoingAE?.length === 1 && startEvents?.length === 0 && endEvents?.length === 0) ? "" :  '.' : ','}
                                              </div>
                                              })}
                                              </div>}
                                              {startEvents.length > 0 && <div className="d-flex flex-wrap">
                                              {startEvents.length > 0 && startEvents.map((each,index) => {
                                                  return <div key={each.adverse_event_mapping_id} className='aechildmbl clickable-string serious-adverse-event' onClick={() => handleAE(each.adverse_event_mapping_id, true)}>
                                                  {<span>{index === 0 ? "Start: ": "" }{each.study_aebank_event_title}{each.isDateOfResolutionGiven === false && <span className='text-danger'>*</span> }</span>}
                                                  {index === startEvents?.length - 1 ? (startEvents?.length === 1 && endEvents?.length === 0) ? "" : '.' : ','}
                                              </div>
                                              })}</div>}
                                              {endEvents.length > 0 && <div className="d-flex flex-wrap">
                                              {endEvents.length > 0 && endEvents.map((each,index) => {
                                                  return <div key={each.adverse_event_mapping_id} className='aechildmbl clickable-string serious-adverse-event' onClick={() => handleAE(each.adverse_event_mapping_id, true)}>
                                                  {<span>{index === 0 ?"End: " : ""}{each.study_aebank_event_title}</span>}
                                                  {index === endEvents?.length - 1 ? (endEvents?.length === 1) ? "" : '.' : ','}
                                              </div>
                                              } )}</div>}
                                          </div>

                                          <div className='adveventstyl'>
                                            {ongoingSAE.length > 0 && <div className="d-flex flex-wrap">
                                              {ongoingSAE.length > 0 && ongoingSAE.map((each,index) => {
                                                  return <div key={each.adverse_event_mapping_id} className='aechildmbl clickable-string serious-adverse-event' onClick={() => handleAE(each.adverse_event_mapping_id, true)}>
                                                  <span className="text-danger">{each.study_aebank_event_title}-{each.serious_adverse_event_name}</span>
                                                  {index === ongoingSAE.length-1 ? (ongoingSAE?.length === 1 && startSaEvents?.length === 0 && endSaEvents?.length === 0) ? "" :  '.'  : ','}
                                              </div>
                                              })}</div>}
                                            {startSaEvents.length > 0 && <div className="d-flex flex-wrap">
                                              {startSaEvents.length > 0 && startSaEvents.map((each,index) => {
                                                  return <div key={each.adverse_event_mapping_id} className='aechildmbl clickable-string serious-adverse-event' onClick={() => handleAE(each.adverse_event_mapping_id, true)}>
                                                  {<span>{index === 0 ? "Start: ": "" }<span className="text-danger">{each.study_aebank_event_title}-{each.serious_adverse_event_name}</span></span>}
                                                  {index === startSaEvents?.length - 1 ? (startSaEvents?.length === 1 && endSaEvents?.length === 0) ? "" : '.' : ','}
                                              </div> 
                                              })}</div>}
                                              {endSaEvents.length > 0 && <div className="d-flex flex-wrap">
                                              {endSaEvents.length > 0 && endSaEvents.map((each,index) => {
                                                  return <div key={each.adverse_event_mapping_id} className='aechildmbl clickable-string serious-adverse-event' onClick={() => handleAE(each.adverse_event_mapping_id, true)}>
                                                  {<span>{index === 0 ? "End: ": "" }<span className="text-danger">{each.study_aebank_event_title}-{each.serious_adverse_event_name}</span></span>}
                                                  {index === endSaEvents?.length - 1 ?(endSaEvents?.length === 1) ? "" : '.' : ','}
                                              </div>
                                              })}</div>}
                                          </div>

                                      </div>)
                                })}
                            </div>
                        </div>
                    </div>
                </Row>
            )})}
    </>
}



